import styled from 'styled-components/macro';
import { HERO_SECTION_BACKGROUND_SECOND } from '@yme/tokens/colors';
import { Z_INDEX } from '@yme/tokens/zindex';
import { escapeImageUrl } from '@yme/utils/common';
export const HeroIframeWrapperStyled = styled.div `
  background-size: cover;
  background: url(${({ preview = '' }) => `'${escapeImageUrl(preview)}'`}) no-repeat center;
  position: absolute;
  z-index: ${Z_INDEX.level0};
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  & > span {
    display: grid;
  }

  & > span:before {
    content: '';
    width: 100%;
    padding-top: 56.25%;
    grid-area: 1 / 1 / 2 / 2;
  }

  iframe {
    transform: ${({ isLargeDesktopView }) => (isLargeDesktopView ? 'scale(1.26)' : 'scale(1.8)')};

    visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: cover;
    pointer-events: none;

    @media only screen and (min-width: 1809px) and (max-width: 1980px) {
      transform: scale(1.35);
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${HERO_SECTION_BACKGROUND_SECOND};
  }
`;
